export const config = {
  MILLISECONDS_PER_TICK: 1000,
  TOAST_VISIBILITY_IN_TICKS: 4,
  PAGE_TITLE_SUFFIX: 'Kaboodle Customer Dashboard',
};
